import React, { useEffect, useState } from 'react'
import a from '../assest/desktop/Slide1.JPG';
import b from '../assest/desktop/Slide2.JPG';
import c from '../assest/desktop/Slide3.JPG';
import d from '../assest/desktop/Slide4.JPG';
import e from '../assest/desktop/Slide5.JPG';
import f from '../assest/desktop/Slide6.JPG';
import g from '../assest/desktop/Slide7.JPG';
import h from '../assest/desktop/Slide8.JPG';
import i from '../assest/desktop/Slide9.JPG';
import j from '../assest/desktop/Slide10.JPG';
import k from '../assest/desktop/Slide11.JPG';
import l from '../assest/desktop/Slide12.JPG';
import m from '../assest/desktop/Slide13.JPG';
import n from '../assest/desktop/Slide14.JPG';
import o from '../assest/desktop/Slide15.JPG';
import p from '../assest/desktop/Slide16.JPG';
import q from '../assest/desktop/Slide17.JPG';


import { FaAngleRight } from "react-icons/fa6";
import { FaAngleLeft } from "react-icons/fa6";


const BannerProduct = () => {
    const [currentImage,setCurrentImage] = useState(0)

    const desktopImages = [
        a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q
    ]

    const mobileImages = [
         a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q
    ]

    const nextImage = () =>{
        if(desktopImages.length - 1 > currentImage){
            setCurrentImage(preve => preve + 1)
        }
    }

    const preveImage = () =>{
        if(currentImage != 0){
            setCurrentImage(preve => preve - 1)
        }
    }


    useEffect(()=>{
        const interval = setInterval(()=>{
            if(desktopImages.length - 1 > currentImage){
                nextImage()
            }else{
                setCurrentImage(0)
            }
        },5000)

        return ()=> clearInterval(interval)
    },[currentImage])

  return (
    <div className='container mx-auto px-4 rounded '>
        <div className='h-56 md:h-72 w-full bg-slate-200 relative'>

                <div className='absolute z-10 h-full w-full md:flex items-center hidden '>
                    <div className=' flex justify-between w-full text-2xl'>
                        <button onClick={preveImage} className='bg-white shadow-md rounded-full p-1'><FaAngleLeft/></button>
                        <button onClick={nextImage} className='bg-white shadow-md rounded-full p-1'><FaAngleRight/></button> 
                    </div>
                </div>

                {/**desktop and tablet version */}
              <div className='hidden md:flex h-full w-full overflow-hidden'>
                {
                        desktopImages.map((imageURl,index)=>{
                            return(
                            <div className='w-full h-full min-w-full min-h-full transition-all' key={imageURl} style={{transform : `translateX(-${currentImage * 100}%)`}}>
                                <img src={imageURl} className='w-full h-full'/>
                            </div>
                            )
                        })
                }
              </div>


                {/**mobile version */}
                <div className='flex h-full w-full overflow-hidden md:hidden'>
                {
                        mobileImages.map((imageURl,index)=>{
                            return(
                            <div className='w-full h-full min-w-full min-h-full transition-all' key={imageURl} style={{transform : `translateX(-${currentImage * 100}%)`}}>
                                <img src={imageURl} className='w-full h-full object-cover'/>
                            </div>
                            )
                        })
                }
              </div>


        </div>
    </div>
  )
}

export default BannerProduct